export default __webpack_public_path__ + "static/media/search.face664a.svg";